import { atom, selector } from 'recoil'
import { formatQuoteList, deltaUpdateQuoteList } from '@/utils/orderBook'

export const _orderBookState = atom({
  key: '_OrderBook',
  default: {
    symbol: '',
    bids: [],
    asks: [],
    ts: 0,
    prevTs: 0
  }
})

export const orderBookState = selector({
  key: 'OrderBook',
  get: ({ get }) => get(_orderBookState),
  set: (
    { get, set, reset },
    { newValue, isSnapshot = false, resetDefault = false }
  ) => {
    const orderBook = get(_orderBookState)
    if (resetDefault) {
      reset(_orderBookState)
    } else if (isSnapshot) {
      newValue.asks = formatQuoteList(newValue.asks)
      newValue.bids = formatQuoteList(newValue.bids)
      set(_orderBookState, newValue)
    } else {
      // delta order book data
      newValue.asks = deltaUpdateQuoteList(orderBook.asks, newValue.asks)
      newValue.bids = deltaUpdateQuoteList(orderBook.bids, newValue.bids, false)
      set(_orderBookState, newValue)
    }
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})
